import { render } from "./FeeInvoice.vue?vue&type=template&id=cbff366c"
import script from "./FeeInvoice.vue?vue&type=script&lang=js"
export * from "./FeeInvoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__